<template>
    <a-modal :visible="visible"
             title="数量"
             :width="`${modalWidth*0.8}px`"
             :mask="true"
             @cancel="close"
             :bodyStyle="customStyle"
             class="modal-content"
             :maskClosable="false"
             :centered="true"
    >
        <div slot="footer">
            <a-space size="small">
                <a-button @click="close" :disabled="loading">关闭</a-button>
                <a-button @click="handleOk" type="primary" :disabled="loading">确定</a-button>
            </a-space>
        </div>

        <a-col :span="24">
            <show-stock :height="220" :goodsId="param.goodsId" :default-warehouse-id="param.orderWarehouseId" :orderOrganizationId="param.orderOrganizationId"></show-stock>
        </a-col>
        <a-col :span="24" style="margin-top: 8px;">
            <sale-input-history :height="200" :goodsId="param.goodsId" :orderOrganization="param.orderOrganizationId" :sendOrganization="param.sendOrganizationId"></sale-input-history>
        </a-col>
        <a-col :span="24" style="margin-top: 8px;">
            <go-edit-table :height="240" :columns="detailColumns" :dataSource="detailList" ref="detailTable" :edit="true" allEdit>
                <template slot="colorId" slot-scope="{text, record}">
                    <div>{{ `[${record.colorNo}]${record.colorName}` }}</div>
                </template>
            </go-edit-table>
        </a-col>
    </a-modal>
</template>

<script>
import {ModalMixin} from "@/utils/ModalMixin";
import {mixin} from "@/utils/mixin";
import GoEditTable from "@/components/tools/GoEditTable";
import {BillInputQtyMixin} from "@/utils/BillInputQtyMixin";
import ShowStock from "@/views/order/base/modal/ShowStock";
import SaleInputHistory from "@views/order/base/modal/SaleInputHistroy";

export default {
    name: "JoinSaleInputInputQtyModal",
    components: {SaleInputHistory, ShowStock, GoEditTable},
    mixins: [ModalMixin, mixin, BillInputQtyMixin],
    data: function () {
        return {
            param: {
                goodsId: null,
                orderWarehouseId: null,
                orderOrganizationId: null,
                data: null,
            }
        }
    },
    methods: {},
}
</script>

<style scoped>

</style>
